import $ from 'jquery';
import 'slick-carousel';

const selectors = {
	wrapper: '.js-slider-wrap'
};

const settings = {
	dots: true,
	arrows: false
};

const $slider = $(selectors.wrapper);

const init = () => $slider.not('.slick-initialized').slick(settings);

const render = () => {
	if ($slider.length) {
		init();
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/slider/index.js